
import { HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { throwError as observableThrowError } from 'rxjs';
import { DeployParams } from 'src/app/deployParams';
import { LoaderService } from '../loader.service';
import { UserActivityService } from '../userActivity.service';
import { DynamicTranslations } from 'src/locale/dynamicTranslations';
import { ErrorLevel, ErrorType } from 'src/app/models/enums';
import { NotificationService } from '../notification.service';
import { ICustomNotification } from 'src/app/models/notification/customNotification.interface';
import { StorageService } from '../util/storage.service';
import { environment } from 'src/environments/environment';

export class BaseService {
  isErrorRegistrated = false;

  constructor(
    protected loaderService: LoaderService,
    protected userActivityService: UserActivityService,
    protected notificationService: NotificationService,
    protected storageService: StorageService) { }

  protected httpOptions = {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*' }),
  };

  protected httpHeaders = new HttpHeaders({
    // eslint-disable-next-line @typescript-eslint/naming-convention
    'Content-Type': 'application/json',
     accept: 'application/utf8+json, application/json;q=0.9, text/plain;q=0.8, */*;q=0.7'
  });

  protected baseUrlWebClientController = environment.baseURL + 'webclient/';
  protected slowCacheController = environment.useSportBookOffer ? environment.sportBookBaseURL + 'slowCache/' : environment.baseURL + ' /';
  protected offerController = environment.useSportBookOffer ? environment.sportBookBaseURL + 'offer/' : environment.baseURL + 'webclient/';
  protected baseUrlWebClientAffiliate = environment.baseURL + 'affiliate/';
  protected tcketManagerBaseUrl = environment.ticketManagerBaseURL;
  protected notificationClientURL = environment.notificationServiceURL + 'Subscription/';
  protected baseUrlMobileClient = environment.baseURL + 'mobileWeb/';
  protected baseUrlAndroid = environment.baseURL + 'android/';
  protected baseUrlWebTicketManager = environment.baseURL + 'webTicketManager/';
  protected baseUrlTicketManager = environment.baseURL + 'ticketManager/';
  protected baseUrlTerminal = environment.baseURL + 'terminal/';
  protected cacheChangesUrl = environment.cacheChangesURL === environment.sportBookBaseURL ? environment.cacheChangesURL + 'offer/' : environment.cacheChangesURL + 'webclient/';
  protected sportBookOfferController = environment.sportBookBaseURL + 'offer/';

  protected handleError(error: Error, showErrorMessage: boolean = true, dontReloadPage: boolean = false) {
    if (environment.isMaintinanceBreak) {
      return observableThrowError(error || 'Server error');
    }
    // in a real world app, we may send the server to some remote logging infrastructure
    // instead of just logging it to the console
    if (error.stack) {
      const callerLine = error.stack.split('\n')[4];
      const index = callerLine.indexOf('at ');
      const clean = callerLine.slice(index + 2, callerLine.length);
      console.log(error.toString());
      console.log('STACK: \n' + error.stack);
      console.log('INDEX: \n' + index);
      console.log('CLEAN: \n' + clean);
    }
    this.loaderService.showHideLoader(false);
    if (error instanceof HttpErrorResponse && error.status === 401) {
      this.loaderService.showHideLoader(false);
      this.storageService.authToken = null;
      this.storageService.userName = null;
      this.storageService.freeBetBalance = null;
      this.storageService.accountBalance = null;
      const notification = {
        title: DynamicTranslations.notification_title,
        message: DynamicTranslations.notification_LoginFailedWrongToken_ErrorMessage,
        errorLevel: ErrorLevel.Notification,
        errorType: ErrorType.Reload
      } as ICustomNotification;
      this.notificationService.forwardDataToNotification(notification);
    } else if (showErrorMessage) {
      this.showErrorMessage(dontReloadPage);
    }
    return observableThrowError(error || 'Server error');
  }

  private showErrorMessage(dontReloadPage: boolean): void {
    if (!this.isErrorRegistrated) {
      this.userActivityService.stopAllComunication();
      this.isErrorRegistrated = true;
      // let error = new NotificationDialogError();
      // let error = new CustomError();
      // error.title = DynamicTranslations.communication_Error_title;
      // error.errorMessage = DynamicTranslations.communication_Error_errorMessage;
      // error.errorLevel = ErrorLevel.Fatal;
      // this._errorService.forwardDataToError(error);
      if (environment.reloadPageOnCommunicationError && !dontReloadPage) {
        setTimeout(() => {
          parent.location.reload();
          if (window.parent) {
            window.parent.postMessage({ reloadPage: true }, environment.postMessageURL);
          }

        }, 300);
        return;
      }

      // CALL LOGOUT
      // sessionStorage.removeItem('currentUser');
      // if (this.router.url === '/login') {
      //   return observableThrowError(error);
      // }
      // this.router.navigate(['/login']);
    }
    const notification: ICustomNotification = {
      title: DynamicTranslations.communication_Error_title,
      message: DynamicTranslations.communication_Error_errorMessage,
      errorLevel: ErrorLevel.Warning,
      errorType: ErrorType.Fatal
    } as ICustomNotification;

    this.notificationService.forwardDataToNotification(notification);
  }

  openErrorNotification(message: string) {
    const error: ICustomNotification = {
      title: DynamicTranslations.notification_title,
      message,
      errorLevel: ErrorLevel.Notification,
    } as ICustomNotification;
    this.notificationService.forwardDataToNotification(error);
  }
}

